import { render, staticRenderFns } from "./CargoListTemplateView.vue?vue&type=template&id=273effe9&scoped=true&"
import script from "./CargoListTemplateView.vue?vue&type=script&lang=js&"
export * from "./CargoListTemplateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273effe9",
  null
  
)

export default component.exports